import { CatalogsListDataRequest } from '@entities/catalog/api/catalog-types';
import { DEFAULT_COUNT_ON_PAGE } from '@shared/ui/pagination/constants';

export const DEFAULT_CATALOGS_LIST_PARAMETERS: CatalogsListDataRequest = {
    search: '',
    take: DEFAULT_COUNT_ON_PAGE.value,
    skip: null,
    sort: 'desc',
    order: 'created_at',
};
